import { makeStyles } from '@material-ui/core';

import logo from 'assets/one_logo_full.png';
import { REACT_APP_LOGO_BASE_URL } from 'config';

const useStyles = makeStyles({
  logo: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    overflow: 'hidden',
  },
  containerLogo: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
});

export function Logo(): JSX.Element {
  const classes = useStyles();
  const subDomain = window.location.hostname.split('.').slice(0, 2).join('.');

  return (
    <div className={classes.containerLogo}>
      <img
        src={`${REACT_APP_LOGO_BASE_URL}${subDomain}_light.png`}
        alt="logo-light"
        className={classes.logo}
        onError={e => {
          (e.target as HTMLImageElement).onerror = null;
          (e.target as HTMLImageElement).src = logo;
        }}
      />
    </div>
  );
}
